import { onCommonDeployError, setDeploymentRequestLoading } from "../../../basic/_fetch/_fetchHelpers";
import { store } from "../../../../../redux/store";
import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { authNotify, onAuthError, saveLocationForRedirect } from "../../../../../helpers/data/get/user";
import { API_BUILDER_DEPLOY_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export const createBuilderDeployment = ({
                                onSuccess, onError, projectID, tokenID
                            }) => {
    setDeploymentRequestLoading(true);

    const {bodyCloud, bodyServer, bodyStack, currentCloud} = store.getState().deployment;

    createFetch({
        URL: `${API_BUILDER_DEPLOY_NODE}?project=${projectID}${typeof tokenID === 'number' ? `&cloud=${tokenID}` : ''}`,
        method: 'POST',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        body: {
            cloud: {
                ...bodyCloud,
                ...{provider: currentCloud.code}
            },
            server: bodyServer,
            stack: {
                vars: bodyStack.vars,
                integrated_features: bodyStack.integrated_features,
                extended_features: bodyStack.extended_features,
                subscriptions: bodyStack.subscriptions,
                form_app: bodyStack.form_app,
            },
        },
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
        },
        onError: response => {

            setDeploymentRequestLoading(false);
            if (onError) onError(response);

            let {error, responseBody} = response;

            switch (error.status) {
                case 402:
                    if (!!responseBody.payment_url) {
                        setDeploymentRequestLoading(true);
                        window.location.assign(responseBody.payment_url);
                    }
                    break;
                case 401:
                    saveLocationForRedirect();
                    onAuthError();
                    authNotify();
                    break;
                default:
                    onCommonDeployError(response);
                    return;
            }
        },
    });
}